import { IRenderingSignalR } from "Data/interfaces/ListagemArquivos/IListFilesResponse";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import { ContentRenderizando } from "./styles";

interface ILoadingRender {
  fileViewerAutodesk: IRenderingSignalR | undefined;
}

const LoadingRender: FC<ILoadingRender> = ({ fileViewerAutodesk }) => {
  const { t } = useTranslation('panels');

  const getNameEtapa = () => {
    const etapa =
      (fileViewerAutodesk?.etapa && fileViewerAutodesk?.etapa < 4) && fileViewerAutodesk?.progress == 100
        ? fileViewerAutodesk?.etapa + 1
        : fileViewerAutodesk?.etapa;

    switch (etapa) {
      case 0: return t('loadingRender.stage0');
      case 1: return t('loadingRender.stage1');
      case 2: return t('loadingRender.stage2');
      case 3: return t('loadingRender.stage3');
      case 5: return t('loadingRender.stage5');
      default: return t('loadingRender.stageDefault');
    }
  };

  return (
    <ContentRenderizando key="render" iserror={`${fileViewerAutodesk?.etapa === 5}`}>
      <div className="infoRenderizando">
        <div>
          <CircularProgressbar
            className="circularProgress"
            strokeWidth={14}
            styles={buildStyles({ pathColor: '#0081FF', trailColor: '#cdcdcd' })}
            value={
              (fileViewerAutodesk?.progress == 100
                ? 0
                : fileViewerAutodesk?.progress) ?? 0
            }
            maxValue={100}
          />
        </div>
        <div className="infoEtapas">
          <label>
            {t('loadingRender.stagePrefix')}{' '}
            {fileViewerAutodesk?.progress == 100
              ? fileViewerAutodesk?.etapa + 1
              : fileViewerAutodesk?.etapa ?? 0}{' '}
            {t('loadingRender.stageOf')}
          </label>
          <p>{getNameEtapa()}</p>
        </div>
      </div>
    </ContentRenderizando>
  );
}

export default LoadingRender;
